import * as selectors from './my.selectors';
import reducer from './my.reducers';

export default reducer;
export { selectors, reducer };
export { MyAction } from './my.actions';
export { MyEffects } from './my.effects';
export { MyState } from './my.models';
export { MyService } from './my.service';
